import { GridApi } from "ag-grid-enterprise";
import { FeatureTypes } from "entity-app/constants";
import { TGoverningSourceTypes } from "entity-app/shared-components/entity-dateblock/models";

export const resetGridFilters = (props: {
  setListFilter: any;
  api: GridApi | undefined;
}) => {
  const { setListFilter, api } = props;
  try {
    const currentFilters: any = api?.getFilterModel();
    const currentFilterCols = Object.keys(currentFilters);
    currentFilterCols.forEach((col: string) => {
      api?.destroyFilter(col);
    });

    setTimeout(() => {
      setListFilter(null);
      api?.onFilterChanged();
    });
  } catch {
    //
  }
};

export function getFeatureTypeString(id: number): FeatureTypes {
  return Object.keys(FeatureTypes).find(
    (key) => (FeatureTypes[key as keyof typeof FeatureTypes] as number) === id
  )! as unknown as FeatureTypes;
}

/**
 * Method to checlk if the given instance id is present in the event log.
 * @param featureInstanceId
 * @param eventLog
 * @param featureId
 * @returns
 */
export function hasTheFeature(featureInstanceId: string, eventLog: any) {
  let hasFeature = false;
  if (featureInstanceId) {
    const objectId = eventLog.object_id;
    const { info } = eventLog;
    hasFeature =
      featureInstanceId === objectId ||
      info?.feature_instance_ids?.includes(featureInstanceId) ||
      info?.linked_features?.some((feature: any) => {
        return feature?.id === featureInstanceId;
      });
  }
  return hasFeature;
}

export const getValueFromDotPath = (obj: any, path: string) => {
  if (!path) return undefined;
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

export const setNestedValue = (obj: any, path: string, value: any) => {
  const keys = path.split(".");
  const lastKey = keys.pop();

  // String.prototype.split always returns a non-empty array (even "" -> [""]),
  // so keys.pop() can never be undefined; this guard's return is unreachable.
  /* v8 ignore next */
  if (lastKey === undefined) return; // Handle empty path safely

  const target = keys.reduce((acc, key) => {
    if (!acc[key]) acc[key] = {};
    return acc[key];
  }, obj);

  target[lastKey] = value;
};

export const getTypeOfGoverningSourceTitle = (
  featureTypeId: number
): TGoverningSourceTypes => {
  let type: TGoverningSourceTypes = "Manually Set Date";
  switch (featureTypeId) {
    case FeatureTypes.ACTIVITIES as number:
      type = "Linked Activity";
      break;
    case FeatureTypes.PLANNING_ONLY_SUBMITTAL as number:
      type = "Submittal Plan";
      break;
    case FeatureTypes.SUBMITTALS as number:
      type = "Linked Submittal";
      break;
    default:
      break;
  }
  return type;
};
